import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function SalespersonFilter({ value, onChange, options = [] }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="salesperson-filter"
        className="h-10 w-[220px] bg-card"
      >
        <SelectValue placeholder="Vendedor" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="salesperson-option-all">
          Todos os vendedores
        </SelectItem>
        {options.map((sp) => (
          <SelectItem
            key={sp.salesperson_id}
            value={sp.salesperson_id}
            data-testid={`salesperson-option-${sp.salesperson_id}`}
          >
            {sp.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
